/**
 * Script de diagnóstico para verificar datos del usuario
 * Ejecutar en la consola del navegador
 */
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { db, auth } from "../firebase/firebaseConfig";

export async function checkUserData() {
  const user = auth.currentUser;
  if (!user) {
    return;
  }

  // User data check removed
  
  try {
    // Verificar documento de usuario
    const userDocRef = doc(db, "users", user.uid);
    const userDocSnap = await getDoc(userDocRef);

    if (userDocSnap.exists()) {
      const userData = userDocSnap.data();

      if (userData?.familyId) {
        // Has familyId
      } else {
        // No familyId - check families
        const familiesSnap = await getDocs(collection(db, "families"));

        familiesSnap.forEach((docSnap) => {
          const data = docSnap.data();
          if (
            data.ownerId === user.uid ||
            (Array.isArray(data.admins) && data.admins.includes(user.uid)) ||
            (Array.isArray(data.members) && data.members.includes(user.uid))
          ) {
            // Found family but user doc not updated
          }
        });
      }
    } else {
      // User doc doesn't exist
    }
  } catch (error) {
  }
}

// Exportar para uso en consola
(window as any).checkUserData = checkUserData;
